import { AdminFeature } from "@/pages/Private/pages/FeatureManagement/schema/admin-feature";
import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

/**
 * Does the ticket's company have the customer Support UI (spec §8, PREC-3939 decision 1)? Read
 * off the admin feature list: one row per (feature, company override) plus the global row with
 * `companyId: null`. Mirrors `feature.repo.ts` `getAll` — a company override wins over the global
 * row; no row at all means the feature is off.
 */
export const isSupportUiActive = (
	features: readonly AdminFeature[] | undefined,
	companyId: number
): boolean => {
	const rows = (features ?? []).filter((row) => row.feature === FeaturesCodes.SUPPORT_TICKETS);
	const override = rows.find((row) => row.companyId === companyId);

	if (override) {
		return override.active;
	}

	return rows.find((row) => row.companyId === null)?.active ?? false;
};
